var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer__inner"},[_c('div',{staticClass:"app-footer-right"},[_vm._v(" Copyright © "),_c('a',{staticClass:"ml-1 mr-1",attrs:{"href":"https://imperu.com.pe"}},[_vm._v("Inmobiliaria Miraflores Perú S.A.C")]),_vm._v(" 2024 ")])])])
}]

export { render, staticRenderFns }